<template>
  <div :style="{ width: provincelist.width }" class="provinceBox fc-ac-jc">
    <p class="pt-20 pb-20 fs-18 bold">请选择你所在的高考省份</p>
    <div class="listBox">
      <div
        v-for="(item, ind) in province"
        :key="ind"
        class="provinceItem fc-ac-jc"
      >
        <div
          class="provinceBorder fc-ac-jc pointer"
          :class="provinceActive == item.province ? 'provinceBG' : ''"
          style="font-size: 15px;"
          @click="provinceClick(item, ind)"
        >
          {{ item.province }}
        </div>
      </div>
    </div>
    <div class="provinceConfirm pointer" @click="provinceConfirm">确定</div>
  </div>
</template>
<script>
import {getCookie,setCookie} from '@/utils/common'
export default {
  props: {
    provincelist: Object,
  },
  data(props) {
    return {
      province: [],
      provinceActive: getCookie("province"),
      provinceId:''
    };
  },
  methods: {
    async getProvince() {
      const res = await this.$http.fetch(
        "api/basedata/getBusinessProvince",
        {}
      );
      if (res.status === 200) {
        this.province = res.data;
      }
    },
    provinceConfirm() {
      if (this.provinceActive == '') {
        return
      }
      setCookie("province", this.provinceActive, 1);
      setCookie("province_id", this.provinceId, 1);
      this.$emit("closeProvince",this.provinceActive,this.provinceId);
    },
    provinceClick(val, ind) {
      this.provinceActive = val.province;
      this.provinceId = val.id;
    },
  },
  mounted() {
    this.getProvince();
  },
  created() {},
};
</script>
<style lang="scss">
.provinceBox {
  background: #fff;
  padding: 0 30px;
  .listBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    grid-template-rows: 4;
    grid-template-columns: 9;
  }
  .provinceItem {
    margin-bottom: 15px;
    width: calc(100% / 9);

    .provinceBorder {
      width: 60%;
      padding: 5px 0;
      border: 1px solid #eee;
      border-radius: 5px;
    }
    .provinceBG {
      background: #3c78ff;
      color: #fff;
      border: 1px solid #3c78ff;
    }
  }
  .provinceConfirm {
    padding: 8px 100px;
    background: #3c78ff;
    color: #fff;
    margin: 30px 0;
    border-radius: 15px;
  }
}
</style>